import React from "react";
import { Link } from "react-router-dom";
import PartnerProjekte from "../components/sections/PartnerProjekte";
import { ArrowRight } from "lucide-react";

export default function PartnerProjektePage() {
  return (
    <div className="min-h-screen bg-[#081328] text-[#F7F6F2] pt-28" data-testid="partner-projekte-page">
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none opacity-30"
             style={{ background: "radial-gradient(ellipse at 20% 20%, #F2D6D6 0%, transparent 50%), radial-gradient(ellipse at 80% 80%, #D4AF37 0%, transparent 60%)" }} />
        <div className="relative container-sat max-w-5xl py-20">
          <div className="text-[#D4AF37] text-xs tracking-[0.4em] uppercase mb-5">Das SAT-Ökosystem</div>
          <h1 className="serif text-5xl md:text-7xl font-light tracking-tight leading-[1.05]">
            Ein größeres<br/>
            <span className="italic" style={{ color: "#D4AF37" }}>Ganzes.</span>
          </h1>
          <p className="text-white/65 text-base md:text-xl mt-6 max-w-2xl leading-relaxed">
            SAT ist nicht nur eine Akademie — es ist eine Bewegung. Hier siehst du alle Projekte und Schwesterprojekte, die unser Ökosystem ausmachen.
          </p>
        </div>
      </section>

      <PartnerProjekte />

      <section className="max-w-4xl mx-auto px-6 py-20 text-center border-t border-white/5">
        <h3 className="serif text-3xl md:text-4xl font-light leading-tight">Wirst du Teil dieser Bewegung?</h3>
        <p className="text-white/55 mt-4">Werde SAT Partner — empfehle weiter und verdiene mit.</p>
        <Link to="/referrals" className="mt-8 inline-flex items-center gap-2 px-7 py-3 bg-[#D4AF37] text-[#081328] font-semibold rounded-full hover:bg-[#e3c252] transition" data-testid="cta-werde-partner">
          Jetzt SAT Partner werden <ArrowRight size={14} />
        </Link>
      </section>
    </div>
  );
}
